import classNames from "classnames";
import Dropdown from "react-bootstrap/Dropdown";

import RotatingChevron from "../RotatingChevron";
import "./DropDownToggle.css";
import useToggle from "../useToggle";

interface DropDownToggleProps<T> {
  disabled?: (impactCategory: T) => boolean;
  onChange: (impactCategory: T) => void;
  options: Array<T>;
  renderOption: (option: T) => React.ReactNode;
  selectedOption: T;
  dropDownClassname?: string;
  dropDownMenuClassname?: string;
}

export default function DropDownToggle<T>(props: DropDownToggleProps<T>) {
  const {
    disabled = () => false,
    onChange,
    options,
    renderOption,
    selectedOption,
    dropDownClassname,
    dropDownMenuClassname,
  } = props;

  const [showDropdown, setShowDropdown] = useToggle(false);

  const handleChange = (value: T | null) => {
    if (value === null) {
      throw new Error("value should not be clearable.");
    }
    onChange(value);
  };

  return (
    <Dropdown
      className={classNames("DropDownToggle", dropDownClassname)}
      show={showDropdown}
      onToggle={setShowDropdown}
    >
      <Dropdown.Toggle
        className={classNames(
          "DropDownToggle__PageToggle",
          {
            DropDownToggle__PageToggle__Active: showDropdown,
          },
          dropDownClassname
        )}
        variant="none"
      >
        {renderOption(selectedOption)}
        <RotatingChevron
          className={classNames("DropDownToggle__Chevron", {
            DropDownToggle__Chevron__Expanded: showDropdown,
          })}
          expanded={showDropdown}
        />
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={classNames("DropDownToggle__Menu", dropDownMenuClassname)}
      >
        {options.map((option, index) => (
          <Dropdown.Item
            disabled={disabled(option)}
            key={index}
            className={classNames("DropDownToggle__Item", {
              DropDownToggle__Item__Active: option === selectedOption,
              DropDownToggle__Item__First: index === 0,
              DropDownToggle__Item__Last: index === options.length - 1,
            })}
            onSelect={() => handleChange(option)}
          >
            {renderOption(option)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
